import request from "@/utils/request"

/****************
 *    Labos
 ****************/
export function getLabos() {
  return request({
    url: "/api/brands",
    method: "get"
  })
}

/**
 *
 * @param {Number} id - Labo id to get
 */
export function getLabo(id) {
  return request({
    url: `/api/labos/${id}`,
    method: "get"
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function createLabo(data, params = {}) {
  return request({
    url: "/api/labos",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function updateLabo(id, data, params = {}) {
  return request({
    url: `/api/labos/${id}`,
    method: "put",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - labo id to delete
 */
export function deleteLabo(id) {
  return request({
    url: `/api/labos/${id}`,
    method: "delete"
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request params
 */
export function importLabos(params, data) {
  return request({
    url: "/api/brands/import",
    method: "post",
    params,
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
